module.exports = __webpack_public_path__ + "img/h2.2b9fa6f3.png";